import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useBannerActionsStyles = makeStyles({
  root: {
    position: 'relative',
    ...shorthands.gridArea('actions'),

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    columnGap: tokens.spacingVerticalS,
    marginTop: tokens.spacingVerticalXL,
    marginBottom: tokens.spacingVerticalXL,
    marginRight: tokens.spacingHorizontalXXL,
  },

  WhiteButton: {
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  TransparentButton: {
    backgroundColor: tokens.colorSubtleBackground,
    color: 'white',
    ...shorthands.borderColor('white'),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  ApplyingAction: {},
  ApplyingActionLabel: {
    color: 'white',
  },
});
